module.exports = __webpack_public_path__ + "img/auth_succ.328fb8de.png";